import type { ResolvedTheme } from './antdTheme';

/**
 * WEB-490 — resolve the theme applied to the document root, guarding the public
 * player against inheriting the cabinet/visitor OS theme.
 *
 * On a public player host (a user-owned custom domain, where funnels render),
 * an unauthenticated visitor has no persisted theme, so the resolved theme
 * follows the visitor's `prefers-color-scheme`. A dark-OS visitor would get
 * `data-theme='dark'`, which flips `--color-text-primary` to white and renders
 * default-theme funnels white-on-white. Force light there instead. A funnel's
 * own palette/theme is applied inline on its container and still overrides this,
 * so custom-themed funnels are unaffected.
 *
 * @param resolvedTheme - the theme resolved from the user's preference / OS.
 * @param onPublicPlayerHost - true when the SPA is served on a player host.
 */
export function publicSafeHtmlTheme(
  resolvedTheme: ResolvedTheme,
  onPublicPlayerHost: boolean,
): ResolvedTheme {
  return onPublicPlayerHost ? 'light' : resolvedTheme;
}
